import { createMuiTheme } from "@material-ui/core/styles";

const palette = {
  primary: {
    main: "#00B0FF",
    light: "#e4f6ff", //"rgb(51, 191, 255)",
    dark: "rgb(0, 123, 178)",
    contrastText: "#fff",
  },
  secondary: {
    main: "#4b545b",
    light: "rgb(111, 118, 123)",
    dark: "rgb(52, 58, 63)",
    contrastText: "#fff",
  },
  background: {
    main: "#fff",
    secondary: "#413f3f",
    hover: "#f1f1f1",
  },
  text: {
    disabled: "rgba(0, 0, 0, 0.38)",
    hint: "rgba(0, 0, 0, 0.38)",
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "#ccc",
  },
  border: {
    main: "rgba(224, 224, 224, 1)",
  },
};
const themeName = "faktual";

const typography = {
  headline: {
    color: "#656565",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.35417em",
    fontSize: "2.8rem",
    fontWeight: 400,
  },
  h2: {
    marginLeft: "-.02em",
    color: "#5c5e62",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.2",
    fontSize: "3.75rem",
    fontWeight: 300,
  },
  h5: {
    color: "#5c5e62",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.2",
    fontSize: "1.55rem",
    fontWeight: 400,
  },
  h6: {
    marginTop: "0.05em",
    // marginBottom: "1.05em",
    color: "#b7b7b7",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.2",
    fontSize: "1.15rem",
    fontWeight: 400,
  },
  display2: {
    marginLeft: "-.02em",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.13333em",
    fontSize: "2.8125rem",
    fontWeight: 400,
  },
  fontWeightLight: 300,
  display3: {
    marginLeft: "-.02em",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    letterSpacing: "-.02em",
    lineHeight: "1.30357em",
    fontSize: "3.5rem",
    fontWeight: 400,
  },
  display4: {
    marginLeft: "-.04em",
    color: "#ccc",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    letterSpacing: "-.04em",
    lineHeight: "1.14286em",
    fontSize: "7rem",
    fontWeight: 300,
  },
  fontWeightRegular: 400,
  display1: {
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.20588em",
    fontSize: "2.125rem",
    fontWeight: 400,
  },
  button: {
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 0.87)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  body2: {
    color: "#949494",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.71429em",
    fontSize: "0.875rem",
    fontWeight: 400,
  },
  caption: {
    color: "#ccc",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.275em",
    fontSize: "0.75rem",
    fontWeight: 300,
  },
  fontSize: 14,
  fontWeightMedium: 500,
  title: {
    color: "#949494",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.16667em",
    fontSize: "3.3125rem",
    fontWeight: 500,
  },
  subHeading: {
    color: "#949494",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.5em",
    fontSize: "1rem",
    fontWeight: 400,
  },
  body1: {
    color: "rgba(0, 0, 0, 0.87)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: "1.46429em",
    fontSize: "0.875rem",
    fontWeight: 400,
  },
};
const theme = createMuiTheme({ palette, typography, themeName });
export default theme;
